<!DOCTYPE html>
<html>

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Inicio sesión - Autorizador</title>

    <link href="https://fonts.googleapis.com/css2?family=Roboto&amp;display=swap" rel="stylesheet">
</head>

<body>
    <div>
        <div class="container-fluid">
            <div class="row no-gutter justify-content-center">
                <div class="col-md-8 col-lg-6">
                    <div class="login d-flex align-items-center py-5">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-9 col-lg-8 mx-auto">
                                    <div class="logo"></div>
                                    <hr class="my-4">

                                    <div *ngIf="ClaveUnica">    
                                        <div class="form-group">
                                            <div class="form-group">
                                                <button class="btn-cu btn-m btn-fw btn-block btn-color-estandar" type="button" name="buttoncu" value="login" (click)="loginWithClaveUnica()">
                                                    <span class="cl-claveunica"></span>Iniciar con Clave única
                                                </button>
                                            </div>
                                        </div>                                        
                                    </div>

                                    <div *ngIf="JunjiAD">
                                        <div class="form-group">
                                            <button class="btn microsoft-button btn-block pr-2" type="button" name="buttonju" value="login" (click)="loginWithJunjiAD()"><span class="microsoft-button__icon pr-4">
                                                <img src="../../../assets/libs/login/fonts/junjilogo.svg"
                                                    alt="logo junji">
                                            </span><span class="microsoft-button__text">Iniciar con JUNJI</span></button>
                                        </div>
                                    </div>

                                    <div *ngIf="CorreoMicrosoft">
                                        <div class="form-group">
                                            <button class="btn microsoft-button btn-block pl-3" type="button" name="buttonmi" value="login" (click)="loginWithJunjiAD()">
                                                <span class="microsoft-button__icon pr-1">
                                                    <img src="../../../assets/libs/login/fonts/microsoft.svg" alt="logo junji">
                                                </span>
                                                <span style="padding: 0px 0px 0px 32px;"
                                                    class="microsoft-button__text pr-1">Iniciar con Microsoft
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                        
                                    <div *ngIf="CorreoGoogle">
                                        <div class="form-group">
                                            <button class="btn google-button btn-block pl-4" type="button" name="buttongo" value="login" (click)="loginWithGoogle()">
                                                <span class="google-button__icon">
                                                    <img src="../../../assets/libs/login/fonts/google.svg" alt="logo junji">
                                                </span>
                                                <span class="google-button__text">Iniciar con Google</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div *ngIf="UsuarioGesdep">
                                        <div *ngIf="mostrarBoton" class="form-group">
                                            <button class="btn btn-outline-warning btn-block" id="btnLocal" data-target="#formLocal" (click)="toggleFormOU()">Iniciar con GESDEP</button>
                                        </div>                                          
                                        <div *ngIf="isFormOUExpanded">
                                            <ng-container [formGroup]="UsuarioGesdepForm">
                                                <fieldset>
                                                    <div class="form-group">
                                                        <label for="usuario">Rut</label>
                                                        <input class="form-control" [autocomplete]="false" placeholder="ej: 10186423" formControlName="run" autofocus>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="clave">Clave</label>
                                                        <input type="password" [autocomplete]="false" class="form-control" (keydown.enter)="loginUsuarioGesdep()" placeholder="Clave" formControlName="clave" autocomplete="off">
                                                    </div>
                                                    <div class="form-group">
                                                        <button class="btn btn-primary btn-block" type="button" name="button" value="login" (click)="loginUsuarioGesdep()">Iniciar Sesión</button>
                                                    </div>
                                                </fieldset>
                                            </ng-container>
                                        </div>                        
                                    </div>

                                    <div *ngIf="UsuarioLocal">
                                        <div *ngIf="mostrarBoton" class="form-group">
                                            <button class="btn btn-outline-danger btn-block" data-target="#formInterno" (click)="toggleFormUC()">Iniciar con usuario local de sistema</button>
                                        </div>                                          
                                          <div *ngIf="isFormUCExpanded">
                                            <ng-container [formGroup]="usuarioLocalForm">
                                                <fieldset>
                                                    <div class="form-group">
                                                        <label for="usuario">Nombre de usuario</label>
                                                        <input class="form-control" [autocomplete]="false" placeholder="ej: usuario" formControlName="usuario" autofocus>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="clave">Clave</label>
                                                        <input type="password" [autocomplete]="false" class="form-control" (keydown.enter)="loginUsuarioLocal()" placeholder="Clave" formControlName="clave" autocomplete="off">
                                                    </div>
                                                    <div class="form-group">
                                                        <button class="btn btn-primary btn-block" type="button" name="button" value="login" (click)="loginUsuarioLocal()">Iniciar Sesión</button>
                                                    </div>
                                                </fieldset>
                                            </ng-container>
                                          </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>